export interface ReconSheetLoadDto {
  State: string;
  EntityName: string;
  VertexCompanyCode: string;
}
